import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from 'react-i18next';
import InfoIcon from "assets/svgs/infoIcon.svg";
import { Radio } from "shared/components";
import "./ShipmentTracking.scss";
import ShipmentListItem from "./ShipmentListItem";
import { useParams } from "react-router-dom";
import ShipmentTrackingService from "./ShipmentTrackingService";
import { getTestCenterCycle } from "features/tc-event-dashboard/duck";
import { useSelector, useDispatch } from "react-redux";

const days = [7, 14, 30, 60];

const headerItems = [
  "shippedDate",
  "shipmentTrackingId",
  "contactName",
  "address1",
  "address2",
  "city",
  "state",
  "zip",
];

const ShipmentTracking = (props) => {
  const { t } = useTranslation();
  const table = useRef();
  const select = useRef();
  const [shipmentData, setShipmentData] = useState([]);
  const [checkedItem, setCheckedItem] = useState(7);
  const [tableScrollPosition, setTableScrollPosition] = useState({
    left: true,
    right: false,
  });
  const [selectScrollPosition, setSelectScrollPosition] = useState({
    left: true,
    right: false,
  });
  const results = shipmentData.length ? "" : "no-results-header";
  const dispatch = useDispatch();
  const centerCode =
    useSelector(
      (state) =>
        state.tcEvent.testCenterCycle.testCenterProgram?.testCenter.code
    ) ?? null;
  const { eventId } = useParams();
  const position = (element) => ({
    left: element.target.scrollLeft === 0,
    right:
      element.target.scrollWidth - element.target.scrollLeft ===
      element.target.clientWidth,
  });
  const handleTableScroll = (e) => {
    setTableScrollPosition(position(e));
  };
  const handleSelectScroll = (e) => {
    setSelectScrollPosition(position(e));
  };
  useEffect(() => {
    const tableElement = table.current;
    const selectElement = select.current;
    if (tableElement) {
      tableElement.addEventListener("scroll", handleTableScroll);
    }
    if (selectElement) {
      selectElement.addEventListener("scroll", handleSelectScroll);
    }
    return () => {
      if (tableElement) {
        tableElement.removeEventListener("scroll", handleTableScroll);
      }
      if (selectElement) {
        selectElement.removeEventListener("scroll", handleSelectScroll);
      }
    };
  }, []);
  useEffect(() => {
    if (centerCode === null) {
      dispatch(getTestCenterCycle(eventId));
    }
    if (centerCode) {
      (async () => {
        const shipments = await ShipmentTrackingService.getShipmentTracking(
          centerCode,
          7
        );
        setShipmentData(shipments.data);
      })();
    }
  }, [centerCode]);

  const handleRadioChange = async (e) => {
    setCheckedItem(Number(e.target.value));
    const shipments = await ShipmentTrackingService.getShipmentTracking(
      centerCode,
      e.target.value
    );
    setShipmentData(shipments.data);
  };
  const leftTableClass = tableScrollPosition.left ? "hide-left-fade" : "";
  const rightTableClass = tableScrollPosition.right ? "hide-right-fade" : "";
  const leftSelectClass = selectScrollPosition.left ? "hide-left-fade" : "";
  const rightSelectClass = selectScrollPosition.right ? "hide-right-fade" : "";

  return (
    <div className="shipment-container">
      <h3>{t("shipmentTracking.title")}</h3>
      <div className="shipment-info">
        <InfoIcon />
        {t("shipmentTracking.info")}
      </div>
      <div
        className={`select-container ${rightSelectClass} ${leftSelectClass}`}
      >
        <div className="shipment-select" ref={select}>
          <div className="shipment-scrollable-content">
            <div className="shipment-select-label">
              {t("shipmentTracking.shippedDate")}
            </div>
            <div className="radio-input-container">
              {days.map((numberOfDays) => (
                <div className="radio-input" key={numberOfDays}>
                  <Radio
                    value={numberOfDays}
                    label={`${t("shipmentTracking.label", {
                      number: numberOfDays,
                    })}`}
                    checked={checkedItem === numberOfDays}
                    onChange={handleRadioChange}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div
        className={`scrollable-container ${leftTableClass} ${rightTableClass}`}
      >
        <div className="shipment-scrollable-content" ref={table}>
          {
            <div className="shipment-table-container">
              <div
                className={`shipment-table-item shipment-table-header ${results}`}
              >
                {headerItems.map((item) => (
                  <div>{t(`shipmentTracking.${item}`)}</div>
                ))}
              </div>
              {shipmentData.map(
                (shipmentItem) =>
                  shipmentData.length && (
                    <ShipmentListItem item={shipmentItem} />
                  )
              )}
            </div>
          }
          <div className="scroll-fade-right"></div>
        </div>
      </div>
      {!shipmentData.length && (
        <div className="shipment-info no-results">
          <InfoIcon />
          {t("shipmentTracking.noResults")}
        </div>
      )}
      <div className="button-container">
        <button
          className="btn btn-outline btn-small"
          onClick={() => {
            props.history.goBack();
          }}
        >
          {t("common.labels.back")}
        </button>
      </div>
    </div>
  );
};

export default ShipmentTracking;
